import React from "react";
import { Globe2, MapPin } from "lucide-react";

/**
 * Bandeau dual : consultation à distance (Monde entier) + Présentiel local.
 * À placer en tête de page ou juste après le hero pour les piliers Géobiologie,
 * Magnétisme et Bilan.
 *
 * Props :
 * - isFr : bool
 * - localZone : ex. "Verviers · Province de Liège" (FR) ou "Verviers · Province of Liège" (EN)
 * - showLocal : si false, n'affiche que la pastille distancielle (pour Bilan 19€)
 */
export const ConsultationModeBadge = ({
  isFr = true,
  localZone,
  showLocal = true,
  testId = "consultation-mode-badge",
}) => {
  return (
    <div
      className="mt-8 mb-2 flex flex-wrap items-center gap-3"
      data-testid={testId}
    >
      <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#00F0FF]/40 bg-[#00F0FF]/10 text-[#00F0FF] text-[11px] font-mono-tech uppercase tracking-[0.22em]">
        <Globe2 size={13} strokeWidth={1.8} />
        {isFr ? "Consultation à distance · Monde entier" : "Remote consultation · Worldwide"}
      </span>
      {showLocal && (
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 text-[#D4AF37] text-[11px] font-mono-tech uppercase tracking-[0.22em]">
          <MapPin size={13} strokeWidth={1.8} />
          {isFr ? `Présentiel · ${localZone || "Verviers · Province de Liège"}` : `On-site · ${localZone || "Verviers · Province of Liège"}`}
        </span>
      )}
    </div>
  );
};
